import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Define initial state
const initialState = {
  raw_material_stock: [],
  loading: false,
  error: null,
};

// Create async thunk for fetching all tenders
export const fetchRawMaterial = createAsyncThunk(
  'tenders/fetchRawMaterial',
  async (id ) => {
    const response = await axios.get(`${API_URL}/raw-material-stock/${id}`);
    return response.data;
  }
);

// Create async thunk for deleting a tender
export const deleteRawMaterial = createAsyncThunk(
  'tenders/deleteRawMaterial',
  async (id) => {
    await axios.delete(`${API_URL}/raw-material-stock/${id}`);
    return id;
  }
);

// Create slice
const rawMaterialSlice = createSlice({
  name: 'rawMaterialStock',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRawMaterial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRawMaterial.fulfilled, (state, action) => {
        state.loading = false;
        console.log('action payload',action.payload);
        state.raw_material_stock = action.payload;
      })
      .addCase(fetchRawMaterial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteRawMaterial.fulfilled, (state, action) => {
        state.raw_material_stock = state.raw_material_stock.filter(
          (tender) => tender.id !== action.payload
        );
      });
  },
});

export default rawMaterialSlice.reducer;
